import React from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"

const SAMLConfigurationsListItemSection = ({ children, title }) => (
  <ItemRow
    className="dark"
    itemRowHeaderContent={(
      <span>{title}</span>
    )}
    itemRowHeaderContentClassName="font-semibold"
    itemRowBody={children}
  />
)

SAMLConfigurationsListItemSection.propTypes = {
  children: types.node.isRequired,
  title: types.string.isRequired,
}

export default SAMLConfigurationsListItemSection
